import React, {Component} from 'react';
import Actionbar from "../Common/Actionbar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBell} from "@fortawesome/free-solid-svg-icons";
import Navbar from "../Common/Navbar";
import { DatePicker } from "react-persian-datepicker";
import moment from "moment-jalaali";
import API from "../../services/API";
import {toast} from "react-toastify";
import Toast from "../Common/Toast";
const styles = {
    calendarContainer: 'calendarContainer',
    dayPickerContainer: 'dayPickerContainer',
    monthsList: 'monthsList',
    daysOfWeek: 'daysOfWeek',
    dayWrapper: 'dayWrapper',
    selected: 'selected',
    heading: 'heading',
    prev: 'prev',
    next: 'next',
    title: 'title'
}

class WorkShifts extends Component {
    state  =  {
        today:moment(),
        tomorrow: moment().add(1,'days'),
        present_today: 0,
        present_tomorrow: 0,
        workdays: {
            'Saturday' : 0,
            'Monday' : 0,
            'Tuesday' : 0,
            'Wednesday' : 0,
            'Thursday' : 0,
            'Friday' : 0,
            'Sunday' : 0,

        }
    }
    onInputChange = (event) => {
        let inputValue = event.target.value;
        if(event.target.name === 'present_today') {
            inputValue = 1 - this.state.present_today;
            const date = this.state.today.format("YYYY-MM-DD");
            if(inputValue){
                API.setAvailability(date)
                    .then((response) => {
                        toast.success(response.user_message);

                    })
                    .catch((error) => {
                        toast.error(error.response.data.user_message);
                    });
            }
            else  {
                API.RemoveAvailability(date)
                    .then((response) => {
                        toast.success(response.user_message);

                    })
                    .catch((error) => {
                        toast.error(error.response.data.user_message);
                    });
            }
        }
        if(event.target.name === 'present_tomorrow') {
            inputValue = 1 - this.state.present_tomorrow;
            const date = this.state.tomorrow.format("YYYY-MM-DD");
            if(inputValue){
                API.setAvailability(date)
                    .then((response) => {
                        toast.success(response.user_message);

                    })
                    .catch((error) => {
                        toast.error(error.response.data.user_message);
                    });
            }
            else  {
                API.RemoveAvailability(date)
                    .then((response) => {
                        toast.success(response.user_message);

                    })
                    .catch((error) => {
                        toast.error(error.response.data.user_message);
                    });
            }
        }
        const inputName = event.target.name;

        this.setState({[inputName]: inputValue});
    }
    render() {
        return (
            <React.Fragment >
                <Actionbar noBack={1}/>
                <Toast  />
                <section className="container mt-5 pt-5">
                    <div className="row">
                        <div className="col-12 text-center text-primary">
                            <FontAwesomeIcon icon={faBell} className='text-big' />
                            <h3 className='mt-2  small'>
                                شیفت های کاری
                            </h3>
                        </div>
                        <div className="col-12 rtl mt-4">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">

                                        <div className="col-8 small">
                                            وضعیت حضور امروز :
                                            <DatePicker
                                                calendarStyles={styles}
                                                inputFormat="jYYYY/jM/jD"
                                                className="form-control pdate-picker w-50 d-inline text-center border-0 super-small"
                                                value={this.state.today}


                                            />
                                        </div>
                                        <div className="custom-control custom-checkbox col-4 ">

                                            <input type="checkbox"
                                                   className="custom-control-input" id="is_personal_address"                                                        name="present_today"
                                                   placeholder=""
                                                   checked={this.state.present_today}
                                                   value = {1}
                                                   onChange={this.onInputChange}
                                                  />
                                            &nbsp;
                                            <label htmlFor="is_personal_address"  className="custom-control-label super-small text-success">حضور دارم</label>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 rtl mt-2">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-8 small">
                                            وضعیت حضور فردا :
                                            <DatePicker
                                                calendarStyles={styles}
                                                inputFormat="jYYYY/jM/jD"
                                                className="form-control pdate-picker w-50 d-inline text-center border-0 super-small"
                                                value={this.state.tomorrow}


                                            />
                                        </div>
                                        <div className="custom-control custom-checkbox col-4 ">

                                            <input type="checkbox"
                                                   className="custom-control-input" id="is_personal_address"                                                        name="present_tomorrow"
                                                   placeholder=""
                                                   value = {1}
                                                   checked={this.state.present_tomorrow}
                                                   onChange={this.onInputChange}
                                                  />
                                            &nbsp;
                                            <label htmlFor="is_personal_address"  className="custom-control-label super-small text-success">حضور دارم</label>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.workdays ?
                                <div className="col-12 mt-4">
                                    <div className="card text-center">
                                        <div className="card-header  bg-success text-white">
                                            روزهای کاری تعیین شده برای شما

                                        </div>
                                        <div className="card-body rtl">
                                            {
                                                this.state.workdays.Saturday === 1 ?
                                                    <span className="badge badge-pill mx-2 p-2 badge-success bg-dark ">شنبه</span>
                                                    : ''
                                            }
                                            {
                                                this.state.workdays.Sunday === 1 ?
                                                    <span className="badge badge-pill mx-2 p-2 badge-success bg-dark ">یکشنبه</span>
                                                    : ''
                                            }
                                            {
                                                this.state.workdays.Monday === 1 ?
                                                    <span className="badge badge-pill mx-2 p-2 badge-success bg-dark ">دوشنبه</span>
                                                    : ''
                                            }
                                            {
                                                this.state.workdays.Tuesday === 1 ?
                                                    <span className="badge badge-pill mx-2 p-2 badge-success bg-dark ">سه شنبه</span>
                                                    : ''
                                            }
                                            {
                                                this.state.workdays.Wednesday === 1 ?
                                                    <span className="badge badge-pill mx-2 p-2 badge-success bg-dark ">چهارشنبه</span>
                                                    : ''
                                            }
                                            {
                                                this.state.workdays.Thursday === 1 ?
                                                    <span className="badge badge-pill mx-2 p-2 badge-success bg-dark ">پنج شنبه</span>
                                                    : ''
                                            }
                                            {
                                                this.state.workdays.Friday === 1 ?
                                                    <span className="badge badge-pill mx-2 p-2 badge-success bg-dark ">جمعه</span>
                                                    : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }

                    </div>
                </section>
                <Navbar  />
            </React.Fragment>
        );
    }
    componentDidMount= () => {
        const today = this.state.today.format("YYYY-MM-DD");
        API.GetAvailability(today)
            .then((response) => {
              this.setState({present_today : response.results.is_available})
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
        const tomorrow = this.state.tomorrow.format("YYYY-MM-DD");
        API.GetAvailability(tomorrow)
            .then((response) => {
              this.setState({present_tomorrow : response.results.is_available})
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
        API.GetWorkdays()
            .then((response) => {
                this.setState({workdays : response.results.workdays})
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
}

export default WorkShifts;